(() => {
  const instances = new Map();

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function getTrackProgress(track, viewportHeight) {
    const rect = track.getBoundingClientRect();
    const scrollable = Math.max(rect.height - viewportHeight, 1);
    return clamp((-rect.top) / scrollable, 0, 1);
  }

  function segmentedOpacity(localProgress) {
    const fadeInEnd = 0.2;
    const holdEnd = 0.8;

    if (localProgress <= 0 || localProgress >= 1) return 0;
    if (localProgress < fadeInEnd) return localProgress / fadeInEnd;
    if (localProgress <= holdEnd) return 1;
    return (1 - localProgress) / (1 - holdEnd);
  }

  function renderScenes(scenes, progress) {
    const count = scenes.length;
    if (!count) return;

    if (progress <= 0) {
      scenes.forEach((scene, index) => {
        const isFirst = index === 0;
        scene.style.opacity = isFirst ? '1' : '0';
        scene.style.transform = isFirst ? 'scale(1)' : 'scale(0.994)';
        scene.classList.toggle('is-active', isFirst);
        if (scene.classList.contains('fse-scene--pinned-static')) {
          const textPane = scene.querySelector('.fse-split__text');
          if (textPane) textPane.style.opacity = isFirst ? '1' : '0';
        }
      });
      return;
    }

    const segment = 1 / count;
    const sceneAlphas = [];
    const staticGroupAlpha = new Map();

    scenes.forEach((scene, index) => {
      const start = index * segment;
      const local = clamp((progress - start) / segment, 0, 1);
      const alpha = segmentedOpacity(local);
      sceneAlphas[index] = alpha;

      if (scene.classList.contains('fse-scene--pinned-static')) {
        const groupKey = scene.dataset.fseStaticGroup || `scene-${index}`;
        staticGroupAlpha.set(groupKey, Math.max(staticGroupAlpha.get(groupKey) || 0, alpha));
      }
    });

    scenes.forEach((scene, index) => {
      const alpha = sceneAlphas[index];
      if (scene.classList.contains('fse-scene--pinned-static')) {
        const groupKey = scene.dataset.fseStaticGroup || `scene-${index}`;
        const groupAlpha = staticGroupAlpha.get(groupKey) || 0;
        scene.style.opacity = groupAlpha.toFixed(3);
        scene.style.transform = `scale(${(0.994 + groupAlpha * 0.006).toFixed(4)})`;
        const textPane = scene.querySelector('.fse-split__text');
        if (textPane) textPane.style.opacity = alpha.toFixed(3);
      } else {
        scene.style.opacity = alpha.toFixed(3);
        scene.style.transform = `scale(${(0.994 + alpha * 0.006).toFixed(4)})`;
      }
      scene.classList.toggle('is-active', alpha > 0.98);
    });
  }

  function buildInstance(section) {
    if (!section || instances.has(section)) return;

    const track = section.querySelector('[data-fse-track]');
const scenes = Array.from(section.querySelectorAll('[data-fse-scene]'));
const reveals = Array.from(section.querySelectorAll('[data-fse-reveal]'));
const scrollCue = section.querySelector('[data-fse-scroll-cue]');
let rafId = null;

    const update = () => {
  const vh = window.innerHeight || 1;

  if (track) {
    const progress = getTrackProgress(track, vh);
    renderScenes(scenes, progress);
  }

  if (scrollCue) {
    const sectionRect = section.getBoundingClientRect();
    const isWithinSection = sectionRect.top < vh * 0.85 && sectionRect.bottom > vh * 1.4;
    scrollCue.classList.toggle('is-visible', isWithinSection);
  }

  rafId = null;
};

    const queueUpdate = () => {
      if (rafId) return;
      rafId = window.requestAnimationFrame(update);
    };

    const onScroll = () => queueUpdate();
    const onResize = () => queueUpdate();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    let revealObserver = null;
    if ('IntersectionObserver' in window && reveals.length) {
      revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.target.classList.toggle('is-visible', entry.isIntersecting);
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
      );
      reveals.forEach((item) => revealObserver.observe(item));
    } else {
      reveals.forEach((item) => item.classList.add('is-visible'));
    }

    queueUpdate();
    document.body.classList.add('fse-story-active');

    instances.set(section, {
      destroy() {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onResize);
        if (rafId) window.cancelAnimationFrame(rafId);
        if (revealObserver) revealObserver.disconnect();

        instances.delete(section);
        if (instances.size === 0) {
          document.body.classList.remove('fse-story-active');
        }
      }
    });
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-fse-section]').forEach(buildInstance);
  }

  function unload(event) {
    const section = event.target?.querySelector?.('[data-fse-section]') || event.target;
    if (instances.has(section)) {
      instances.get(section).destroy();
    }
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', unload);
})();
